'use strict';

var App = App || {};

App.InitBehavior = function () {
  'use strict';

  var initialize = function initialize() {
    _initQuicklink();
    _smoothScrolling();
    _detectTouch();
  };

  var _initQuicklink = function _initQuicklink() {
    quicklink.listen({
      ignores: [function (uri, elem) {
        return elem.hasAttribute('data-noprefetch');
      }]
    });
  };

  var _smoothScrolling = function _smoothScrolling() {
    $('a[href*="#"]').on('click', function (e) {
      e.preventDefault();
      var target = $(this).attr('href');

      if (target.length > 1 && document.querySelector(target)) {
        $(target).velocity('scroll', {
          duration: 2000,
          offset: -40,
          easing: 'ease-in-out'
        });
      }
    });
  };

  /**
   * Detect a touch device, add class 'touch' to body if so
   * @return {void}
   */
  var _detectTouch = function _detectTouch() {
    if ('ontouchstart' in window) {
      // "ontouchstart" in document.documentElement) {
      $('body').addClass('touch');
    }
  };

  return {
    initialize: initialize
  };
}();